import React from "react";
import CommonGrid from "./CommonGrid";
import { ColumnType } from "../../../../components/Grid/constants";
import {
  RequestState,
  RequestStateRaw,
  InitiativeState,
  InitiativeStateRaw,
} from "../../enum";
import { displayHowManyDaysLeft, showProp, showDegrees } from "../../CroUtils";
import { map, join } from "lodash";

export const ArchiveDefault = (props) => {
  const columns = [
    {
      filterable: true,
      field: "archived",
      label: "Datum předání k Archivaci",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      sortable: true,
      field: "lastName",
      label: "Příjmení",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      sortable: true,
      field: "firstName",
      label: "Jméno",
      type: ColumnType.TEXT,
      width: "5%",
    },
    {
      sortable: false,
      field: "degrees",
      label: "Tituly",
      type: ColumnType.JSX,
      jsx: (row) => showDegrees(row.titleBefore, row.titleAfter),
      width: "10%",
    },
    {
      sortable: true,
      filterable: true,
      field: "birthDate",
      label: "Datum narození",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      sortable: true,
      filterable: true,
      field: "ovmName",
      label: "Podpůrný orgán",
      type: ColumnType.TEXT,
      width: "8%",
    },
    {
      sortable: true,
      filterable: true,
      field: "concatenatedWorkingPositions",
      label: "Funkce",
      type: ColumnType.TEXT,
      width: "18%",
    },
    {
      sortable: true,
      filterable: true,
      field: "lastActiveDate",
      label: "Datum ukončení funkce",
      type: ColumnType.DATE,
      width: "10%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const ArchiveRequest = (props) => {
  const columns = [
    {
      field: "archived",
      label: "Datum předání k Archivaci",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "firstName",
      displayField: "person",
      label: "Jméno žadatele",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.firstName : ""),
      width: "19%",
    },
    {
      field: "lastName",
      displayField: "person",
      label: "Příjmení žadatele",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.lastName : ""),
      width: "19%",
    },
    {
      sortable: false,
      filterable: false,
      field: "officialFullName",
      displayField: "officials",
      label: "Funkcionáři",
      type: ColumnType.TEXT,
      mapper: (field) =>
        `${field && field[0] ? field[0]["firstName"] : ""} ${showProp(field, "lastName")}`,
      width: "38%",
    },
    {
      sortable: true,
      filterable: true,
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: RequestState,
      type: ColumnType.ENUM,
      mapper: (field) =>
        typeof field === "object" && field ? field.name : field || "",
      width: "8%",
    },
    {
      sortable: false,
      field: "period",
      label: "Lhůta",
      type: ColumnType.JSX,
      jsx: (row) =>
        displayHowManyDaysLeft(row.created, row.state === RequestStateRaw.NEW),
      width: "8%",
    },
    {
      sortable: true,
      filterable: true,
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "8%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};

export const ArchiveInitiatives = (props) => {
  const columns = [
    {
      field: "archived",
      label: "Datum předání k Archivaci",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      field: "firstName",
      displayField: "official",
      label: "Jméno",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.firstName : ""),
      width: "13%",
    },
    {
      field: "lastName",
      displayField: "official",
      label: "Příjmení",
      type: ColumnType.TEXT,
      mapper: (field) => (field ? field.lastName : ""),
      width: "13%",
    },
    {
      field: "concatenatedWorkingPositions",
      displayField: "official",
      label: "Funkce",
      type: ColumnType.TEXT,
      mapper: (obj) =>
        obj
          ? join(
              map(
                obj.workingPositions,
                ({ workingPosition: { name } }) => name,
              ),
              ", ",
            )
          : "",
      width: "13%",
    },
    {
      field: "concatenatedWorkingPositionOrganizations",
      displayField: "official",
      label: "Organizace",
      type: ColumnType.TEXT,
      mapper: (obj) =>
        obj
          ? join(
              map(obj.workingPositions, ({ organization }) => organization),
              ", ",
            )
          : "",
      width: "13%",
    },
    {
      field: "state.name",
      displayField: "state",
      label: "Stav",
      enum: InitiativeState,
      type: ColumnType.ENUM,
      mapper: (field) =>
        typeof field === "object" && field ? field.name : field || "",
      width: "8%",
    },
    {
      field: "sendToOrganization",
      displayField: "organization",
      label: "Postoupeno na",
      type: ColumnType.TEXT,
      width: "10%",
    },
    {
      field: "forwardedDate",
      displayField: "forwardedDate",
      label: "Postoupeno dne",
      type: ColumnType.DATE,
      width: "10%",
    },
    {
      sortable: false,
      field: "period",
      label: "Lhůta",
      type: ColumnType.JSX,
      jsx: (row) =>
        displayHowManyDaysLeft(
          row.created,
          row.state === InitiativeStateRaw.NEW ||
            row.state === InitiativeStateRaw.ACCEPT,
        ),
      width: "7%",
    },
    {
      sortable: true,
      field: "created",
      label: "Vytvořen",
      type: ColumnType.DATE,
      width: "12%",
    },
  ];

  return <CommonGrid {...props} columns={columns} />;
};
